import {
  FC,
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
} from "react";

import PreLiquidationService from "../../../../../../../shared/services/collection/preliquidation";

import { GenericDataFormContext } from "../../../../shared/contexts/GenericDataForm";
import { StepTwoFormContext } from "./StepTwoFormContext";

import { PRELIQUIDATION_PAYMENT_TYPE } from "../../../../shared/interfaces";

export const StepTwoFormProvider: FC<PropsWithChildren> = ({ children }) => {
  const { 
    preliquidationInfo, 
    setCanShowSpinner,
  } = useContext(
    GenericDataFormContext
  );

  const postPaymentMethod = useCallback(async () => {
    try {
      setCanShowSpinner(true);

      await PreLiquidationService.indicatePaymentType({
        numeroPreliquidacion: preliquidationInfo?.numeroPreliquidacion!,
        tipo: PRELIQUIDATION_PAYMENT_TYPE.GROSS_AMOUNT,
      });
    } catch (error) {} finally {
      setCanShowSpinner(false);
    }
  }, [
    setCanShowSpinner,
    preliquidationInfo,
  ]);

  const values = useMemo(
    () => ({
      postPaymentMethod,
    }),
    [
      postPaymentMethod,
    ]
  );

  return (
    <StepTwoFormContext.Provider value={values}>
      {children}
    </StepTwoFormContext.Provider>
  );
};
